import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLoading: false,
    error: null,
    user: null,
    loggedInFirebase: false,
    sessionId:null,
    x:false,
    message:'',
    passwordSet:false
};

const auth = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        set_user: (state, action) => {
            return {
                ...state,
                user: action.payload,
            };
        },
        update_user: (state) => {
            return {
                ...state,
                isLoading: true,
                error: null
            };
        },
        update_user_succeed: (state, action) => {
            return {
                ...state,
                isLoading: false,
                error: null,
                user: action.payload,
            };
        },
        update_user_failed: (state, action) => {
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        },
        load_user: (state) => {
            return {
                ...state,
                isLoading: true,
                error: null
            };
        },
        load_user_succeed: (state, action) => {
            return {
                ...state, 
                isLoading: false,
                error: null,
                user: action.payload,
            };
        },
        login_firebase_succeed: (state) => {
            return {
                ...state,
                loggedInFirebase: true
            };
        },
        load_user_failed: (state, action) => {
            return {
                ...state,
                isLoading: false,
                error: action.payload,
                user: null,
                loggedInFirebase: false,
            };
        },
        login_with_password: (state) => {
            return {
                ...state,
                isLoading: true,
                error: null
            };
        },
        id_token_changed: (state, action) => {
            return {
                ...state,
                token: action.payload,
                loggedInFirebase: true,
            };
        },
        login_with_password_succeed: (state, action) => {
            return {
                ...state, 
                isLoading: false,
                error: null,
                user: action.payload.user,
            };
        },
        login_with_password_failed: (state, action) => {
            return {
                ...state,
                isLoading: false,
                error: action.payload,
                user: null
            };
        },
        logout: (state) => {
            return {
                ...state,
            };
        },
        logout_succeed: () => {
            return initialState;
        },
        reset_state: () => {
            return initialState;
        },
        send_sms_code: (state) => {
            return {
                ...state,
                isLoading: true,
                error: null
            };
        },
        send_sms_code_succeed: (state, action) => {
            return {
                ...state, 
                isLoading: false,
                error: null,
                sessionId:action.payload.sessionId
            };
        },
        send_sms_code_failed: (state, action) => {
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        },

 
        change_password:(state) => {
            return {
                ...state,
                isLoading: true,
                error: null
            };
        },
        change_password_succeed: (state) => {
            return {
                ...state, 
                isLoading: false,
                error: null,
                done:true,
            };
        },
        change_password_failed: (state, action) => {
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        },
        reset_password: (state) => {
            return {
                ...state,
                isLoading: true,
                error: null,
                passwordSet:false
            };
        },
        reset_password_succeed: (state) => {
            return {
                ...state, 
                isLoading: false,
                error: null,
                passwordSet:true
            };
        },
        reset_password_failed: (state, action) => {
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        },
    }
});

export const { reducer, actions } = auth;

export default reducer;